import { NewImage, UnsplashImage } from '@griply/types';

export const buildImageFromUnsplash = (image: UnsplashImage): NewImage => ({
  id: image.id,
  url: image.urls.regular,
  blurHash: image.blur_hash,
  metadata: {
    source: 'unsplash',
    sourceName: 'Unsplash',
    sourceURL: 'https://unsplash.com',
    authorName: image.user.name,
    authorURL: image.user.portfolio_url,
  },
});
